/* global commonL10n */ import { getMediaDeleteConfirmMessage } from "../utils/mediaDeleteConfirm.js";
function assignRmlWarnDelete() {
    window.rmlWarnDelete = ()=>confirm(getMediaDeleteConfirmMessage(commonL10n.warnDelete));
}
export { assignRmlWarnDelete };
